import { getQueryParamsFromUrl } from './url';

const queryParams = getQueryParamsFromUrl();
const isDealerDetailsPage = queryParams && (queryParams?.pagename === 'fyd_ddp' || queryParams?.pagename === 'ddp');

export default isDealerDetailsPage;
